module.exports = __webpack_public_path__ + "assets/img/c640c60a8f6a0e5af1153b6651d54bba.png";